import React, { useState } from 'react';
import { savePref } from "../helpers/prefs_api";
import { Link } from 'react-router-dom';
import { usePageHeaderTrail } from "../Components/Common/DashboardKit/PageHeaderTrailContext";
import { Dropdown, DropdownMenu, DropdownToggle, Form } from 'reactstrap';
import { toggleSidebarMenu } from "../utils/layoutToggle";
//import images
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";

//import Components
//import SearchOption from '../Components/Common/SearchOption';
// import LanguageDropdown from '../Components/Common/LanguageDropdown';
// import WebAppsDropdown from '../Components/Common/WebAppsDropdown';
// import MyCartDropdown from '../Components/Common/MyCartDropdown';
// import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import NotificationDropdown from '../Components/Common/NotificationDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import LightDark from '../Components/Common/LightDark';

import { changeSidebarVisibility } from '../slices/thunks';
import { useSelector, useDispatch, shallowEqual } from "react-redux";

const Header = ({
    pageMeta,
    onChangeLayoutMode,
    layoutModeType,
    headerClass
}) => {
    const dispatch = useDispatch();

    const { sidebarVisibilitytype } = useSelector(state => ({
        sidebarVisibilitytype: state.Layout.sidebarVisibilitytype
    }), shallowEqual);

    const [search, setSearch] = useState(false);
    const toogleSearch = () => {
        setSearch(!search);
    };

    // Round 22 — compact sticky trail published by the page banner.
    const { trail } = usePageHeaderTrail();

    // Round 25 — global table density (comfortable/compact), persisted.
    const [density, setDensity] = React.useState(
        () => localStorage.getItem("ssw:tableDensity") || "comfortable"
    );
    React.useEffect(() => {
        document.documentElement.setAttribute("data-table-density", density);
        localStorage.setItem("ssw:tableDensity", density);
        savePref("tableDensity", density); // Round 40 — roams across machines
    }, [density]);

    const toogleMenuBtn = () => {
        toggleSidebarMenu(dispatch, sidebarVisibilitytype);
    };

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">
                            <div className="navbar-brand-box horizontal-logo">
                                <Link to="/" className="logo logo-dark">
                                    <span className="logo-sm">
                                        <img src={logoSm} alt="" height="22" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src={logoDark} alt="" height="17" />
                                    </span>
                                </Link>

                                <Link to="/" className="logo logo-light">
                                    <span className="logo-sm">
                                        <img src={logoSm} alt="" height="22" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src={logoLight} alt="" height="17" />
                                    </span>
                                </Link>
                            </div>
                            {/* Round 22 (owner feedback): the page banner's title + trail now
                                live HERE — fixed, with links — so they stay visible while the
                                page scrolls (the in-page banner no longer renders the trail).
                                Published via PageHeaderTrailContext by DashboardPageHeader. */}
                            {/* Round 25 — mobile: just "‹ parent" so small screens keep a way back */}
                            {trail && trail.crumbs && trail.crumbs.length >= 2 ? (() => {
                                const parent = trail.crumbs[trail.crumbs.length - 2];
                                const inner = (<><i className="ri-arrow-left-s-line align-bottom" /> {parent.label}</>);
                                return (
                                    <div className="d-flex d-md-none align-items-center ms-2" style={{ minWidth: 0, fontSize: 13 }}>
                                        {parent.to ? (
                                            <Link to={parent.to} className="text-decoration-none text-truncate">{inner}</Link>
                                        ) : parent.onClick ? (
                                            <a role="button" tabIndex={0} onClick={parent.onClick} className="text-truncate" style={{ cursor: "pointer" }}>{inner}</a>
                                        ) : (
                                            <span className="text-muted text-truncate">{inner}</span>
                                        )}
                                    </div>
                                );
                            })() : null}
                            <div className="page-header-title d-none d-md-flex align-items-center ms-3" style={{ minWidth: 0 }}>
                                {trail ? (
                                    <ol className="breadcrumb m-0 topbar-trail" style={{ fontSize: 12.5, flexWrap: "nowrap", whiteSpace: "nowrap", overflow: "hidden" }}>
                                        {trail.crumbs.map((item, idx) => {
                                            const last = idx === trail.crumbs.length - 1;
                                            return (
                                                <li key={`${item.label}-${idx}`} className={`breadcrumb-item ${last ? "active" : ""}`} style={last ? { fontWeight: 600, color: "var(--ssw-text-1, #1c2333)", overflow: "hidden", textOverflow: "ellipsis" } : undefined}>
                                                    {last || (!item.to && !item.onClick) ? (
                                                        <span>{item.label}</span>
                                                    ) : item.onClick ? (
                                                        <a role="button" tabIndex={0} onClick={item.onClick}
                                                           onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); item.onClick(); } }}
                                                           style={{ cursor: "pointer" }}>{item.label}</a>
                                                    ) : (
                                                        <Link to={item.to}>{item.label}</Link>
                                                    )}
                                                </li>
                                            );
                                        })}
                                    </ol>
                                ) : null}
                            </div>
                            {/* MOBILE (Round M1): restore the hamburger, but ONLY below md.
                                On desktop the sidebar keeps its floating << toggle; on phones
                                this is the only way to open the off-canvas drawer. Order -1
                                places it before the logo/back-trail visually. */}
                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none d-md-none"
                                id="topnav-hamburger-icon"
                                aria-label="Open navigation menu"
                                style={{ order: -1 }}>
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>


                            {/* <SearchOption /> */}
                        </div>

                        <div className="d-flex align-items-center">



                            {/* <Dropdown isOpen={search} toggle={toogleSearch} className="d-md-none topbar-head-dropdown header-item">
                                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                                    <i className="bx bx-search fs-22"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                                    <Form className="p-3">
                                        <div className="form-group m-0">
                                            <div className="input-group">
                                                <input type="text" className="form-control" placeholder="Search ..."
                                                    aria-label="Recipient's username" />
                                                <button className="btn btn-primary" type="submit"><i
                                                    className="mdi mdi-magnify"></i></button>
                                            </div>
                                        </div>
                                    </Form>
                                </DropdownMenu>
                            </Dropdown> */}

                            {/* LanguageDropdown */}
                            {/* <LanguageDropdown /> */}

                            {/* WebAppsDropdown */}
                            {/* <WebAppsDropdown /> */}

                            {/* MyCartDropdwon */}
                            {/* <MyCartDropdown /> */}

                            {/* FullScreenDropdown */}
                            {/* <FullScreenDropdown /> */}

                            {/* Dark/Light Mode set */}
                            {/* Round 25 — Ctrl+K quick navigation */}
                            <button
                                type="button"
                                className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                onClick={() => window.dispatchEvent(new Event("ssw:openPalette"))}
                                title="Quick navigation (Ctrl+K)"
                                aria-label="Open quick navigation"
                            >
                                <i className="ri-search-line fs-18"></i>
                            </button>

                            {/* Round 25 — table density toggle */}
                            <button
                                type="button"
                                className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                onClick={() => setDensity((d) => (d === "compact" ? "comfortable" : "compact"))}
                                title={density === "compact" ? "Comfortable tables" : "Compact tables"}
                                aria-label="Toggle table density"
                            >
                                <i className={density === "compact" ? "ri-menu-line fs-18" : "ri-menu-4-line fs-18"}></i>
                            </button>

                            <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            />

                            {/* NotificationDropdown */}
                            <NotificationDropdown />

                            {/* ProfileDropdown */}
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;